<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4 20V4h16v16H4zM2 3a1 1 0 011-1h18a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm5.854 2.854a.5.5 0 10-.708-.708l-2 2a.5.5 0 10.708.708l2-2zm3 2.292a.5.5 0 010 .708l-2 2a.5.5 0 01-.708-.708l2-2a.5.5 0 01.708 0zm0-2.292a.5.5 0 00-.708-.708l-5 5a.5.5 0 00.708.708l5-5z"/></svg>